function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#22293E",
  d: "M23.453 21.545l.234.236.237-.236c.279-.278.61-.5.974-.65.364-.15.754-.229 1.148-.229.394 0 .784.078 1.148.229.364.15.695.372.973.65.279.279.5.61.65.973.151.364.229.755.229 1.148 0 .395-.078.785-.229 1.149-.15.364-.371.694-.65.973l-4.48 4.479-4.477-4.48c-.563-.562-.879-1.325-.879-2.12 0-.796.316-1.56.879-2.122.562-.562 1.325-.879 2.121-.879s1.559.317 2.122.88zm-7.788-2.212V22c-2.122 0-4.157.843-5.657 2.343S7.664 27.878 7.664 30H4.998c0-2.771 1.078-5.434 3.007-7.424 1.929-1.99 4.556-3.15 7.326-3.238l.334-.005zm0-17.333c4.42 0 8 3.58 8 8 0 2.07-.802 4.06-2.238 5.55-1.436 1.491-3.394 2.368-5.463 2.444l-.3.006c-4.42 0-8-3.58-8-8 0-2.07.802-4.06 2.238-5.55 1.436-1.492 3.394-2.368 5.463-2.445l.3-.005zm0 2.667c-2.947 0-5.334 2.386-5.334 5.333s2.387 5.333 5.334 5.333c2.946 0 5.333-2.386 5.333-5.333s-2.387-5.333-5.334-5.333z"
});

function SvgHeartSmallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none",
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartSmallIcon);
export default __webpack_public_path__ + "static/media/heart_small_icon.45f32681.svg";
export { ForwardRef as ReactComponent };